import React from 'react'
import { Text } from '../../elements/Text'
import { LegacyColorName, mq, getColorTheme, LegacyColor } from '../../utils'
import { IProps } from './index'
import { BrandOptions, useBrand } from '../../providers/brandProvider'
import { HeadingBlock as HeadingBlockDefault } from './component'

export const HeadingBlock = (props: IProps) => {
  const theme = useBrand()
  if (theme === BrandOptions.default) {
    return <HeadingBlockDefault {...props} />
  }
  return <HeadingBlockLegacy {...props} />
}

function HeadingBlockLegacy({
  leftAlign,
  small,
  text,
  subheading,
  bgColor,
  eyebrow,
  headingMode,
}: IProps) {
  headingMode = !headingMode ? 'standard' : headingMode
  let headingTheme = ''
  let bgColorTheme
  if (bgColor) {
    bgColorTheme = getColorTheme('legacy', bgColor)
    headingTheme = `heading-block--${LegacyColorName[bgColorTheme.id as LegacyColor]}`
  }

  const headingContent = <Text size={small ? 'xl+' : 'xxl+'}>{text}</Text>

  return (
    <div className={`heading-block ${headingMode} ${headingTheme}`}>
      {eyebrow ? (
        <div className="heading-block__eyebrow">
          <Text size="lg-eyebrow">{eyebrow}</Text>
        </div>
      ) : null}

      {headingMode === 'standard' ? <h1>{headingContent}</h1> : <h2>{headingContent}</h2>}

      {subheading && (
        <div className="subheading">
          <Text size="md">{subheading}</Text>
        </div>
      )}
      <style jsx>
        {`
          .heading-block {
            display: block;
            padding: 24px ${small && !leftAlign ? '6%' : '10%'};
            text-align: ${leftAlign ? 'left' : 'center'};
            color: ${bgColorTheme ? bgColorTheme.textColor : 'initial'};
            background-color: ${bgColorTheme ? bgColorTheme.id : 'initial'};
          }
          .heading-block.compact {
            padding: 0 ${small && !leftAlign ? '6%' : '10%'} 0;
          }
          .heading-block__eyebrow {
            margin-bottom: 1.625rem;
          }
          .subheading {
            max-width: 48.5rem;
            margin: 16px auto 0;
          }
          @media (${mq.tablet}) {
            .heading-block {
              padding: 24px 14%;
            }
          }
          @media (${mq.laptop}) {
            .heading-block {
              padding: 24px ${small ? '22%' : '18%'};
            }
          }
          @media (${mq.desktop}) {
            .heading-block {
              padding: 24px ${small ? '28%' : '20%'};
            }
          }
        `}
      </style>
    </div>
  )
}
